import {action, computed, observable, runInAction} from "mobx";
import BasePaginationStore from "@store/Common/BasePaginationStore";

import service from "@service/index";
import fetchUrl from "@service/fetchUrl";
import {message} from "antd";
import MyAgentStore from '@store/LoginUser/MyAgentStore';

class Item {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        if (data === undefined) {
            return
        }
        for (let attr in data) {
            this[attr] = data[attr];
        }
    }

    // 交易号
    @observable
    id = '';
    //手机号
    @observable
    nick_name = '';
    //昵称
    @observable
    pet_name = '';

    // 类型
    @observable
    giveType = '';

    //会员赠送时间
    @observable
    time = '';
    //会员金额变化
    @observable
    in_money = '';
    @observable
        //平台赠送金额
    donation_amount = '';
    //赠送明细
    @observable
    description = '';
    // 用户id
    @observable
    user_id = '';
}

class PaginationStore extends BasePaginationStore {

}

/**
 * 页面头部筛选过滤器字段值
 */
class FilterStore {
    // 是否被初始化过
    is_init;
    search;
    nick_name;
    pet_name;
    giveType;
    //代理id
    id
    type_time

    @action
    setAttr({nick_name, pet_name, search, giveType, id, type_time}) {
        this.resetAttr()
        this.search = search;
        if (pet_name != '' || pet_name != undefined) {
            this.nick_name = nick_name;
            this.pet_name = pet_name;
            this.id = MyAgentStore.findMyAgentId(pet_name);
        }
        this.type_time = type_time;
        this.giveType = giveType;
        this.is_init = true;
    }

    getAttr() {
        return {
            search: this.search,
            id: this.id,
            nick_name: this.nick_name,
            pet_name: this.pet_name,
            giveType: this.giveType,
            type_time: this.type_time
        }
    }

    setDefault() {
        this.resetAttr();
        this.is_init = true;
    }

    @action
    resetAttr() {
        this.agent = undefined;
        this.search = undefined;
        this.id = undefined;
        this.nick_name = undefined;
        this.pet_name = undefined;
        this.giveType = undefined;
        this.type_time = 6;
        this.is_init = undefined;
    }
}

let filter_store = new FilterStore();

class ItemStore {
    static Type_Normal = '0';
    static Type_Proxy = '1';

    constructor(pagination) {
        this.init(pagination);
    }

    @action
    init(pagination) {
        this.pagination_store = pagination;
    }

    @observable
    item_map = new Map();

    @observable
    pagination_store;

    @observable
    sumInMoney = 0;

    @observable
    sumOutMoney = 0;

    @observable
    sumDonationAmount = 0;

    /**
     * item数组列表
     */
    @computed
    get item_array() {
        let res = [];
        this.item_map.forEach((values, key) => {
            res.push(values)
        })
        return res;
    }

    @action
    reloadDatas(filter) {

        this.new_num = 0;
        this.new_total = 0;
        this.pagination_store.clear();
        if (filter == undefined) {
            if (filter_store.is_init == undefined) {
                filter_store.setDefault()
            }
        } else {
            filter_store.setAttr(filter);
        }
        this.searchByFilter(
            {
                desc: 1,
                order: 'time'
            });
    }

    /**
     * 根据条件搜索 item
     */
    async searchByFilter(page_opts) {
        let page_option = {
            page: this.pagination_store.page_cur,
            page_size: this.pagination_store.page_size,
            ...filter_store.getAttr(),
            ...page_opts
        }
        let res = await this._getItemArray(page_option);
        return res;
    }

    /**
     * 获取 item列表
     */
    async _getItemArray(page_option = {}) {
        let url = fetchUrl.admin.giveawayList;
        let res = await service.fetchData({
            path: url,
            params: {
                ...page_option
            }
        });
        service.responseHandle({
            res: res,
            success_handle: (res) => {
                runInAction(() => {
                    this.item_map.clear();
                    res.data.data.forEach((item, index) => {
                        this.item_map.set(item.id, new Item(item));
                    });
                    this.pagination_store.setAttr(res.data.page);
                    this.sumInMoney = res.data.sumInMoney;
                    this.sumOutMoney = res.data.sumOutMoney;
                });
            },
            fail_handle: (res) => {
                message.error(res.error.error_data, 3);
                this.pagination_store.clear();
                filter_store.resetAttr();
                this.item_map.clear();
            }
        });
        return res;
    }
}

let pagination_store = new PaginationStore();
let item_store = new ItemStore(pagination_store);

export {
    pagination_store,
    filter_store
}
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Statistic/GiveawayLog/GiveawayLogStore.js